import { Typography } from "@material-ui/core"
import { DataBlock } from "../../molecules"
import { getRandomNumber } from "../../utils/Utils";
import './ItemBlock.scss'
import DynamicHtml from "../../molecules/DynamicHtml"

const ItemBlock = ({ title, section, headerRight, onClickSubitem, variant = false }: any) => {

    const TitleBlock = () => {
        return (<div className="headerBlockIter">
            <Typography variant='inherit' color='textPrimary' className="mainTitle color-grey">{title}</Typography>
            {headerRight &&
                <div className="headerTags"><Typography variant='inherit' color='textPrimary' className="headerRight color-grey">
                    <DynamicHtml content={headerRight} />
                </Typography>
                </div>}
        </div>)
    }

    let extraclass = "";
    try {
        let titleAlter = (title && title?.trim() && title.trim().replace(" ", "")) || ""
        //eslint-disable-next-line
        extraclass = (titleAlter && titleAlter?.toLowerCase()?.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '_')) || ""
    } catch {

    }

    return (
        <div className={`${extraclass} itemBlockDiv`}>
            {title && TitleBlock()}
            {section && section.map((sitem: any, index: any) => <DataBlock onClickItem={onClickSubitem} key={index + getRandomNumber()} {...sitem} variant={variant} />)}
        </div>
    )
}

export default ItemBlock